module.exports = __webpack_public_path__ + "img/contratti-privati.7c9e1c9d.svg";